;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();export const textStateConfig = {
	color: {
		primary: {
			label: "Primary",
			css: { color: "var(--color-primary)" },
		},
		secondary: {
			label: "Secondary",
			css: { color: "var(--color-primary-light)" },
		},
	},
	fontSize: {
		sm: {
			label: "Small",
			css: { "font-size": "1.5rem" },
		},
		md: {
			label: "Medium",
			css: { "font-size": "2.5rem" },
		},
		lg: {
			label: "Large",
			css: { "font-size": "4rem" },
		},
		xl: {
			label: "Extra large",
			css: { "font-size": "5rem" },
		},
	},
} as const;

export type TextStateConfig = typeof textStateConfig;
